export const tableStyles = {
  '& .table-container': {
    borderRadius: '8px',
  },
};

export const wrapperStyles = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: '1fr',
    md: '1fr 1fr',
  },
  gap: '24px',
  transition: 'all 0.3s ease',

  '&.expanded': {
    gridTemplateColumns: '1fr 0fr',
    gap: 0,
  },
};

export const sharedTypographyStyles = {
  color: ({ palette }) => palette.text.primary,
};

export const getWrappedTextStyles = (rows = 2) => ({
  whiteSpace: 'normal',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: rows,
  overflow: 'hidden',
});

export const headCellLabelStyles = {
  ...sharedTypographyStyles,
  ...getWrappedTextStyles(),
  display: 'block',
  fontWeight: 600,
  textOverflow: 'ellipsis',
};

export const emptyMessageCellStyles = {
  padding: 0,
};

export const actionCellStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
};
